module.exports = __webpack_public_path__ + "img/Kontakt_Smartphone.bb40a344.jpg";